export default {
	"order.TheOrderAddressModificationHasExceededTheMaximumAllowedNumberOfTimes": "該訂單地址修改已超過最大允許次數",
	"order.TheOnlyChanceForTheOrderToModifyTheAddressIsLeft": "該訂單修改地址的機會只剩下",
	"order.timesPleaseCheckTheInformationCarefullyBeforeSubmitting": "次，請認真核對信息後提交",
	"order.PleaseSelectAnItem": "請選擇商品",
	"order.deleteFailed": "刪除失敗了",
	"order.AddressModifiedSuccessfully": "地址修改成功！",
	"order.orderDoesNotExist": "訂單不存在",
	"order.ParameterError": "參數錯誤!",
	"order.TheNumberOfAddressesThatCanBeModifiedForThisOrderHasBeenExhausted": "本訂單可修改地址的次數已用完",
	"order.TheFollowingIsTheDeliveryAddressForPhysicalGoods": "以下為實物商品收貨地址",
	"order.hint": "提示",
	"order.understood": "知道了",
	"order.ModifiedAddressInformation": "修改後地址信息",
	"order.WhetherTheFollowingProductAddressesAreSynchronouslyModified": "以下商品地址是否同步修改",
	"order.ModifyingTheAddressOnlyChangesTheLogisticsInformationThatHasNotBeenShipped": "·修改地址僅對未發貨的物流信息進行更改",
	"order.TheNumberOfChangesToTheAddressOfEachOrderMustNotExceed": "·每筆訂單地址修改次數不得超過",
	"order.SecondRate": "次",
	"order.Cancel": "取消",
	"order.ConfirmTheChanges": "確認修改"
}